import { FC } from 'react';

import { dom } from 'app/utils';
import { InputText as Component, InputTextProps as Props } from '../external';
import { IInput } from './types';

export interface ITextBox extends IInput<string> {
  type?: 'text' | 'password' | 'email' | 'tel' | 'url';
}

export const TextBox: FC<ITextBox> = ({ id, className, style, disabled, name, type, value, placeholder, tooltip, autoFocus, readOnly, invalid, onBlur, onChange, onFocus, onSubmit }) => {
  const props: Props = { id, style, disabled, name, type, placeholder, tooltip, autoFocus, readOnly, invalid, onBlur, onChange, onFocus,
    className: dom.className('i-component', 'i-input', 'i-textbox', { 'i-invalid': invalid }, className),
    value: (value ?? ''),

    onKeyDown: (onSubmit ? (e) => {
      if (e.key === 'Enter') onSubmit?.(e);
    } : undefined),
  };

  return (
    <Component { ...props }  />
  );
}
